Wee.fn.make('search', {
	init: function() {
		var priv = this.$private;

		priv.initEvents();
	},
	pop: function() {
		var priv = this.$private;

		priv.closeSearch();

		$('ref:searchField').val('');
	}
}, {
	/**
	 * Search events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this,
			$form = $('ref:searchForm');

		$.history.bind({
			submit: 'ref:searchForm'
		});

		$.events.on({
			'ref:search': {
				click: function(e) {
					$form.isDisabled() ?
						scope.openSearch() :
						scope.closeSearch();

					e.stopPropagation();
				}
			},
			'ref:searchForm': {
				click: function(e) {
					e.stopPropagation();
				}
			}
		}, {
			namespace: 'search'
		});
	},

	/**
	 * Open search
	 *
	 * @private
	 */
	openSearch: function() {
		$('ref:searchForm').enable()
			.attr('aria-hidden', false);
		$('ref:search').addClass('-search-exit');
	},

	/**
	 * Close search
	 *
	 * @private
	 */
	closeSearch: function() {
		$('ref:searchForm').disable()
			.attr('aria-hidden', true);
		$('ref:search').removeClass('-search-exit');
	}
});